export default [
  // {
  //   title:
  //     'Empowering Creators: How Found Drives Revenue and Deepens Audience Co...',
  //   image: 'cookingupcash/header.jpg',
  //   link: '/blog/cookingupcash',
  //   topic: 'Nens'
  // },
  {
    title: 'How to decide which social media platform is best for you',
    image: 'bestsocialmediaplatforms/header.jpg',
    link: '/blog/bestsocialmediaplatforms',
    topic: 'General'
  },
  {
    title: 'How to become a social media chef',
    image: 'socialmediachef/header.jpg',
    link: '/blog/socialmediachef',
    topic: 'General'
  },
  // {
  //   title: 'Lockdown cooking changed my life',
  //   image: 'lockdowncooking/header.jpg',
  //   link: '/blog/lockdowncooking',
  //   topic: 'General'
  // },
  // {
  //   title: 'Grow and expand your brand with tiktok',
  //   image: 'growyourbrandwithtiktok/header.jpg',
  //   link: '/blog/growyourbrandwithtiktok',
  //   topic: 'General'
  // },
  {
    title: 'Owner of award-winning restaurants proves his cooking prowess...',
    image: 'babacooks/header.jpg',
    link: '/blog/itsbabacooks',
    topic: 'Creator Stories'
  },
  /* {
    title: 'USA influencer turns her cookery content into cash...',
    image: 'mississippikween/header.jpg',
    link: '/blog/mississippikween',
    topic: 'Creator Stories'
  }, */
  /* {
    title: 'Influencer’s imaginery friend helps her to cooking success',
    image: 'desarae/header.jpg',
    link: '/blog/cookingcomedychaos',
    topic: 'Creator Stories'
  }, */
  {
    title: 'Supporting stars of the future, like Divya',
    image: 'divyateachesechildrenaboutcooking/header.jpg',
    link: '/blog/divyateachesechildrenaboutcooking',
    topic: 'Creator Stories'
  },
  {
    title: 'Lockdown weight loss journey leads to cookery book',
    image: 'georgia/header.jpg',
    link: '/blog/eatwellwithgeorgia',
    topic: 'Creator Stories'
  },
  {
    title: 'School’s out for successful home cook...',
    image: 'luke/header.jpg',
    link: '/blog/cookinginthemidwest',
    topic: 'Creator Stories'
  },
  /* {
    title: 'Influencer is cooking up an exciting future',
    image: 'barefootneighbour/header.jpg',
    link: '/blog/yourbarefootneighbor',
    topic: 'Creator Stories'
  }, */
  {
    title: 'Northeast teacher’s new career is the perfect fit',
    image: 'sophie/header.jpg',
    link: '/blog/fitfooddiary_x',
    topic: 'Creator Stories'
  }
];
